module.exports = __webpack_public_path__ + "img/ag.53a60086.svg";